module.exports = __webpack_public_path__ + "static/img/logo.6eb1d50.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/index1/logo.png
// module id = 1RBi
// module chunks = 7